export function isWord(type: string): boolean {
  return Boolean(type && type.startsWith('WORD_'));
}

export function wordToNoun(wordType: string): string {
  return wordType.replace('WORD_', '');
}
